// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_entitlement_user_binding.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { UserRef } from "../../user/v1/user";
import { AppRef } from "./app";
import { AppUserRef } from "./app_user";
import { AppEntitlementUserBindingRef } from "./app_refs";
import { AppEntitlementRef } from "./app_refs";
import { Any } from "../../../../google/protobuf/any";
import { GrantReason } from "./app_entitlement_user_binding_reasons";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.app.v1.UpdateGrantDurationRequest
 */
export interface UpdateGrantDurationRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string app_user_id = 3;
     */
    appUserId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp new_deprovision_at = 4;
     */
    newDeprovisionAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.app.v1.UpdateGrantDurationResponse
 */
export interface UpdateGrantDurationResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserBinding binding = 1;
     */
    binding?: AppEntitlementUserBinding;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementUserBindingWithReasons
 */
export interface AppEntitlementUserBindingWithReasons {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppAppUserEntitlementIds scope = 1;
     */
    scope?: AppAppUserEntitlementIds;
    /**
     * @generated from protobuf field: string app_user_path = 2;
     */
    appUserPath: string;
    /**
     * @generated from protobuf field: string entitlement_path = 3;
     */
    entitlementPath: string;
    /**
     * @generated from protobuf field: string app_path = 4;
     */
    appPath: string;
    /**
     * @generated from protobuf field: string user_path = 5;
     */
    userPath: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserBinding binding = 6;
     */
    binding?: AppEntitlementUserBinding;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.GrantReason reasons = 7;
     */
    reasons: GrantReason[];
    /**
     * @generated from protobuf field: string app_id = 8;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 9;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string app_user_id = 10;
     */
    appUserId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deprovision_at = 11;
     */
    deprovisionAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListMembershipsResponse
 */
export interface ListMembershipsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementUserBindingWithReasons list = 1;
     */
    list: AppEntitlementUserBindingWithReasons[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.ListMembershipsRequest
 */
export interface ListMembershipsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementRef entitlement_ref = 4;
     */
    entitlementRef?: AppEntitlementRef;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserBindingExpandMask expand_mask = 5;
     */
    expandMask?: AppEntitlementUserBindingExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementUserBindingRef refs = 6;
     */
    refs: AppEntitlementUserBindingRef[];
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppUsersForIdentityWithGrantRequest
 */
export interface ListAppUsersForIdentityWithGrantRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string identity_user_id = 3;
     */
    identityUserId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppUsersForIdentityWithGrantResponse
 */
export interface ListAppUsersForIdentityWithGrantResponse {
    /**
     * The list of app users that may also have grant information.
     * Without a grant, only the tenant, app, and app user ID will be set. With a grant, the whole struct is populated
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementUserBinding bindings = 1;
     */
    bindings: AppEntitlementUserBinding[];
}
/**
 * The AppEntitlementUserBinding represents the relationship that gives an app user access to an app entitlement
 *
 * @generated from protobuf message c1.api.app.v1.AppEntitlementUserBinding
 */
export interface AppEntitlementUserBinding {
    /**
     * The ID of the app associated with the app entitlement
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The ID of the app entitlement that the app user has access to
     *
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * The ID of the app user that has access to the app entitlement
     *
     * @generated from protobuf field: string app_user_id = 3;
     */
    appUserId: string;
    /**
     * The datetime, in RFC3339 format, of when the AppEntitlementUserBinding was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4;
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the AppEntitlementUserBinding was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5;
     */
    deletedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the AppEntitlementUserBinding should be deprovisioned, a revoke ticket will automatically be created at this time.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deprovision_at = 6;
     */
    deprovisionAt?: Timestamp;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef grant_sources = 7;
     */
    grantSources: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementUserBindingHistory
 */
export interface AppEntitlementUserBindingHistory {
    /**
     * The ID of the app associated with the app entitlement
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The ID of the app entitlement that the app user has access to
     *
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * The ID of the app user that has access to the app entitlement
     *
     * @generated from protobuf field: string app_user_id = 3;
     */
    appUserId: string;
    /**
     * The datetime, in RFC3339 format, of when the AppEntitlement was granted
     *
     * @generated from protobuf field: google.protobuf.Timestamp granted_at = 4;
     */
    grantedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the AppEntitlement was revoked
     *
     * @generated from protobuf field: google.protobuf.Timestamp revoked_at = 5;
     */
    revokedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementUserBindingExpandHistoryMask
 */
export interface AppEntitlementUserBindingExpandHistoryMask {
    /**
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementUserBindingHistoryView
 */
export interface AppEntitlementUserBindingHistoryView {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserBindingHistory history = 1;
     */
    history?: AppEntitlementUserBindingHistory;
    /**
     * @generated from protobuf field: string app_user_path = 2;
     */
    appUserPath: string;
    /**
     * @generated from protobuf field: string entitlement_path = 3;
     */
    entitlementPath: string;
    /**
     * @generated from protobuf field: string app_path = 4;
     */
    appPath: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchPastGrantsRequest
 */
export interface SearchPastGrantsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserBindingExpandHistoryMask expand_mask = 4;
     */
    expandMask?: AppEntitlementUserBindingExpandHistoryMask;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserRef app_user_refs = 5;
     */
    appUserRefs: AppUserRef[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs = 6;
     */
    appEntitlementRefs: AppEntitlementRef[];
    /**
     * @generated from protobuf field: repeated string app_ids = 7;
     */
    appIds: string[];
}
/**
 * The SearchPastGrantsResponse message contains a list of past grants and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.app.v1.SearchPastGrantsResponse
 */
export interface SearchPastGrantsResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementUserBindingHistoryView list = 1;
     */
    list: AppEntitlementUserBindingHistoryView[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retrieved.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementUserBindingFeed
 */
export interface AppEntitlementUserBindingFeed {
    /**
     * The ID of the app associated with the app entitlement
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The ID of the app entitlement that the app user has access to
     *
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * The ID of the app user that has access to the app entitlement
     *
     * @generated from protobuf field: string app_user_id = 3;
     */
    appUserId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp date = 4;
     */
    date?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.app.v1.GrantEventType event_type = 5;
     */
    eventType: GrantEventType;
    /**
     * @generated from protobuf field: string ticket_id = 6;
     */
    ticketId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementUserBindingFeedView
 */
export interface AppEntitlementUserBindingFeedView {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserBindingFeed feed = 1;
     */
    feed?: AppEntitlementUserBindingFeed;
    /**
     * @generated from protobuf field: string app_user_path = 2;
     */
    appUserPath: string;
    /**
     * @generated from protobuf field: string entitlement_path = 3;
     */
    entitlementPath: string;
    /**
     * @generated from protobuf field: string app_path = 4;
     */
    appPath: string;
    /**
     * @generated from protobuf field: string ticket_path = 5;
     */
    ticketPath: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchGrantFeedRequest
 */
export interface SearchGrantFeedRequest {
    /**
     * The pageSize where 10 <= pageSize <= 100, default 25.
     *
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * The page_token field for pagination.
     *
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * Control the array of expanded values that are filled out in the response to this request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserBindingExpandHistoryMask expand_mask = 3;
     */
    expandMask?: AppEntitlementUserBindingExpandHistoryMask;
    /**
     * The list of app users to limit the search to.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserRef app_user_refs = 4;
     */
    appUserRefs: AppUserRef[];
    /**
     * The list of app entitlements to limit the search to.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs = 5;
     */
    appEntitlementRefs: AppEntitlementRef[];
    /**
     * Search grant feed, in RFC3339 format, that were created before this timestamp.
     *
     * @generated from protobuf field: google.protobuf.Timestamp before = 6;
     */
    before?: Timestamp;
    /**
     * Search grant feed, in RFC3339 format, that were created after this timestamp.
     *
     * @generated from protobuf field: google.protobuf.Timestamp after = 7;
     */
    after?: Timestamp;
    /**
     * The list of apps to limit the search to.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppRef app_refs = 8;
     */
    appRefs: AppRef[];
    /**
     * The list of C1 users to limit the search to.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserRef user_refs = 9;
     */
    userRefs: UserRef[];
}
/**
 * The SearchGrantFeedResponse message contains a list of grant event results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.app.v1.SearchGrantFeedResponse
 */
export interface SearchGrantFeedResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementUserBindingFeedView list = 1;
     */
    list: AppEntitlementUserBindingFeedView[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retrieved.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementUserBindingExpandMask
 */
export interface AppEntitlementUserBindingExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppUsersWithStandingHighRiskGrantsRequest
 */
export interface SearchAppUsersWithStandingHighRiskGrantsRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserBindingExpandMask expand_mask = 4;
     */
    expandMask?: AppEntitlementUserBindingExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppAppUserEntitlementIds
 */
export interface AppAppUserEntitlementIds {
    /**
     * @generated from protobuf field: string app_user_id = 1;
     */
    appUserId: string;
    /**
     * @generated from protobuf field: string entitlement_id = 2;
     */
    entitlementId: string;
    /**
     * @generated from protobuf field: string app_id = 3;
     */
    appId: string;
    /**
     * @generated from protobuf field: string user_id = 4;
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementUserBindingExpanded
 */
export interface AppEntitlementUserBindingExpanded {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppAppUserEntitlementIds scope = 1;
     */
    scope?: AppAppUserEntitlementIds;
    /**
     * @generated from protobuf field: string app_user_path = 2;
     */
    appUserPath: string;
    /**
     * @generated from protobuf field: string entitlement_path = 3;
     */
    entitlementPath: string;
    /**
     * @generated from protobuf field: string app_path = 4;
     */
    appPath: string;
    /**
     * @generated from protobuf field: string user_path = 5;
     */
    userPath: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppUsersWithStandingHighRiskGrantsResponse
 */
export interface SearchAppUsersWithStandingHighRiskGrantsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementUserBindingExpanded list = 1;
     */
    list: AppEntitlementUserBindingExpanded[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListGrantOriginsRequest
 */
export interface ListGrantOriginsRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string app_user_id = 3;
     */
    appUserId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.GrantOriginWithData
 */
export interface GrantOriginWithData {
    /**
     * @generated from protobuf field: string origin_type = 1;
     */
    originType: string;
    /**
     * @generated from protobuf field: repeated string origin_data = 2;
     */
    originData: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.ListGrantOriginsResponse
 */
export interface ListGrantOriginsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.GrantOriginWithData origins = 1;
     */
    origins: GrantOriginWithData[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchGrantReasonsRequest
 */
export interface SearchGrantReasonsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string app_id = 3;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 4;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string app_user_id = 5;
     */
    appUserId: string;
    /**
     * @generated from protobuf field: repeated string grant_reason_types = 6;
     */
    grantReasonTypes: string[];
    /**
     * @generated from protobuf field: bool include_weak_reasons = 7;
     */
    includeWeakReasons: boolean;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchGrantReasonsResponse
 */
export interface SearchGrantReasonsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.GrantReason reasons = 1;
     */
    reasons: GrantReason[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.GrantSource
 */
export interface GrantSource {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetAppEntitlementUserBindingRequest
 */
export interface GetAppEntitlementUserBindingRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string app_user_id = 3;
     */
    appUserId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetAppEntitlementUserBindingResponse
 */
export interface GetAppEntitlementUserBindingResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserBinding binding = 1;
     */
    binding?: AppEntitlementUserBinding;
}
/**
 * @generated from protobuf message c1.api.app.v1.RemoveGrantDurationRequest
 */
export interface RemoveGrantDurationRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string app_user_id = 3;
     */
    appUserId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.RemoveGrantDurationResponse
 */
export interface RemoveGrantDurationResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserBinding binding = 1;
     */
    binding?: AppEntitlementUserBinding;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchExpiringAppEntitlementsCountRequest
 */
export interface SearchExpiringAppEntitlementsCountRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchExpiringAppEntitlementsCountResponse
 */
export interface SearchExpiringAppEntitlementsCountResponse {
    /**
     * @generated from protobuf field: int64 count = 1;
     */
    count: number;
}
/**
 * @generated from protobuf enum c1.api.app.v1.GrantEventType
 */
export enum GrantEventType {
    /**
     * @generated from protobuf enum value: GRANT_EVENT_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: GRANT_EVENT_TYPE_ADDED = 1;
     */
    ADDED = 1,
    /**
     * @generated from protobuf enum value: GRANT_EVENT_TYPE_REMOVED = 2;
     */
    REMOVED = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class UpdateGrantDurationRequest$Type extends MessageType<UpdateGrantDurationRequest> {
    constructor() {
        super("c1.api.app.v1.UpdateGrantDurationRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "new_deprovision_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UpdateGrantDurationRequest
 */
export const UpdateGrantDurationRequest = new UpdateGrantDurationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateGrantDurationResponse$Type extends MessageType<UpdateGrantDurationResponse> {
    constructor() {
        super("c1.api.app.v1.UpdateGrantDurationResponse", [
            { no: 1, name: "binding", kind: "message", T: () => AppEntitlementUserBinding }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UpdateGrantDurationResponse
 */
export const UpdateGrantDurationResponse = new UpdateGrantDurationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementUserBindingWithReasons$Type extends MessageType<AppEntitlementUserBindingWithReasons> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementUserBindingWithReasons", [
            { no: 1, name: "scope", kind: "message", T: () => AppAppUserEntitlementIds },
            { no: 2, name: "app_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "entitlement_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "binding", kind: "message", T: () => AppEntitlementUserBinding },
            { no: 7, name: "reasons", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GrantReason },
            { no: 8, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "deprovision_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementUserBindingWithReasons
 */
export const AppEntitlementUserBindingWithReasons = new AppEntitlementUserBindingWithReasons$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListMembershipsResponse$Type extends MessageType<ListMembershipsResponse> {
    constructor() {
        super("c1.api.app.v1.ListMembershipsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementUserBindingWithReasons },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListMembershipsResponse
 */
export const ListMembershipsResponse = new ListMembershipsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListMembershipsRequest$Type extends MessageType<ListMembershipsRequest> {
    constructor() {
        super("c1.api.app.v1.ListMembershipsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "entitlement_ref", kind: "message", T: () => AppEntitlementRef },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppEntitlementUserBindingExpandMask },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementUserBindingRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListMembershipsRequest
 */
export const ListMembershipsRequest = new ListMembershipsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppUsersForIdentityWithGrantRequest$Type extends MessageType<ListAppUsersForIdentityWithGrantRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppUsersForIdentityWithGrantRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "identity_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppUsersForIdentityWithGrantRequest
 */
export const ListAppUsersForIdentityWithGrantRequest = new ListAppUsersForIdentityWithGrantRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppUsersForIdentityWithGrantResponse$Type extends MessageType<ListAppUsersForIdentityWithGrantResponse> {
    constructor() {
        super("c1.api.app.v1.ListAppUsersForIdentityWithGrantResponse", [
            { no: 1, name: "bindings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementUserBinding }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppUsersForIdentityWithGrantResponse
 */
export const ListAppUsersForIdentityWithGrantResponse = new ListAppUsersForIdentityWithGrantResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementUserBinding$Type extends MessageType<AppEntitlementUserBinding> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementUserBinding", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }, { readOnlySpec: true }] } } },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }, { readOnlySpec: true }] } } },
            { no: 6, name: "deprovision_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "grant_sources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementUserBinding
 */
export const AppEntitlementUserBinding = new AppEntitlementUserBinding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementUserBindingHistory$Type extends MessageType<AppEntitlementUserBindingHistory> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementUserBindingHistory", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "granted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "revoked_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementUserBindingHistory
 */
export const AppEntitlementUserBindingHistory = new AppEntitlementUserBindingHistory$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementUserBindingExpandHistoryMask$Type extends MessageType<AppEntitlementUserBindingExpandHistoryMask> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementUserBindingExpandHistoryMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_user_id", "app_id", "app_entitlement_id", "ticket_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementUserBindingExpandHistoryMask
 */
export const AppEntitlementUserBindingExpandHistoryMask = new AppEntitlementUserBindingExpandHistoryMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementUserBindingHistoryView$Type extends MessageType<AppEntitlementUserBindingHistoryView> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementUserBindingHistoryView", [
            { no: 1, name: "history", kind: "message", T: () => AppEntitlementUserBindingHistory },
            { no: 2, name: "app_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "entitlement_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementUserBindingHistoryView
 */
export const AppEntitlementUserBindingHistoryView = new AppEntitlementUserBindingHistoryView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchPastGrantsRequest$Type extends MessageType<SearchPastGrantsRequest> {
    constructor() {
        super("c1.api.app.v1.SearchPastGrantsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppEntitlementUserBindingExpandHistoryMask },
            { no: 5, name: "app_user_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserRef },
            { no: 6, name: "app_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef },
            { no: 7, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchPastGrantsRequest
 */
export const SearchPastGrantsRequest = new SearchPastGrantsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchPastGrantsResponse$Type extends MessageType<SearchPastGrantsResponse> {
    constructor() {
        super("c1.api.app.v1.SearchPastGrantsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementUserBindingHistoryView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchPastGrantsResponse
 */
export const SearchPastGrantsResponse = new SearchPastGrantsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementUserBindingFeed$Type extends MessageType<AppEntitlementUserBindingFeed> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementUserBindingFeed", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "date", kind: "message", T: () => Timestamp },
            { no: 5, name: "event_type", kind: "enum", T: () => ["c1.api.app.v1.GrantEventType", GrantEventType, "GRANT_EVENT_TYPE_"] },
            { no: 6, name: "ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementUserBindingFeed
 */
export const AppEntitlementUserBindingFeed = new AppEntitlementUserBindingFeed$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementUserBindingFeedView$Type extends MessageType<AppEntitlementUserBindingFeedView> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementUserBindingFeedView", [
            { no: 1, name: "feed", kind: "message", T: () => AppEntitlementUserBindingFeed },
            { no: 2, name: "app_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "entitlement_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "ticket_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementUserBindingFeedView
 */
export const AppEntitlementUserBindingFeedView = new AppEntitlementUserBindingFeedView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchGrantFeedRequest$Type extends MessageType<SearchGrantFeedRequest> {
    constructor() {
        super("c1.api.app.v1.SearchGrantFeedRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => AppEntitlementUserBindingExpandHistoryMask },
            { no: 4, name: "app_user_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserRef },
            { no: 5, name: "app_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef },
            { no: 6, name: "before", kind: "message", T: () => Timestamp },
            { no: 7, name: "after", kind: "message", T: () => Timestamp },
            { no: 8, name: "app_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppRef },
            { no: 9, name: "user_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchGrantFeedRequest
 */
export const SearchGrantFeedRequest = new SearchGrantFeedRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchGrantFeedResponse$Type extends MessageType<SearchGrantFeedResponse> {
    constructor() {
        super("c1.api.app.v1.SearchGrantFeedResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementUserBindingFeedView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchGrantFeedResponse
 */
export const SearchGrantFeedResponse = new SearchGrantFeedResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementUserBindingExpandMask$Type extends MessageType<AppEntitlementUserBindingExpandMask> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementUserBindingExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_user_id", "app_id", "app_entitlement_id", "user_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementUserBindingExpandMask
 */
export const AppEntitlementUserBindingExpandMask = new AppEntitlementUserBindingExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppUsersWithStandingHighRiskGrantsRequest$Type extends MessageType<SearchAppUsersWithStandingHighRiskGrantsRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppUsersWithStandingHighRiskGrantsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppEntitlementUserBindingExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppUsersWithStandingHighRiskGrantsRequest
 */
export const SearchAppUsersWithStandingHighRiskGrantsRequest = new SearchAppUsersWithStandingHighRiskGrantsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppAppUserEntitlementIds$Type extends MessageType<AppAppUserEntitlementIds> {
    constructor() {
        super("c1.api.app.v1.AppAppUserEntitlementIds", [
            { no: 1, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppAppUserEntitlementIds
 */
export const AppAppUserEntitlementIds = new AppAppUserEntitlementIds$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementUserBindingExpanded$Type extends MessageType<AppEntitlementUserBindingExpanded> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementUserBindingExpanded", [
            { no: 1, name: "scope", kind: "message", T: () => AppAppUserEntitlementIds },
            { no: 2, name: "app_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "entitlement_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementUserBindingExpanded
 */
export const AppEntitlementUserBindingExpanded = new AppEntitlementUserBindingExpanded$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppUsersWithStandingHighRiskGrantsResponse$Type extends MessageType<SearchAppUsersWithStandingHighRiskGrantsResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppUsersWithStandingHighRiskGrantsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementUserBindingExpanded },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppUsersWithStandingHighRiskGrantsResponse
 */
export const SearchAppUsersWithStandingHighRiskGrantsResponse = new SearchAppUsersWithStandingHighRiskGrantsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListGrantOriginsRequest$Type extends MessageType<ListGrantOriginsRequest> {
    constructor() {
        super("c1.api.app.v1.ListGrantOriginsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListGrantOriginsRequest
 */
export const ListGrantOriginsRequest = new ListGrantOriginsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantOriginWithData$Type extends MessageType<GrantOriginWithData> {
    constructor() {
        super("c1.api.app.v1.GrantOriginWithData", [
            { no: 1, name: "origin_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "origin_data", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GrantOriginWithData
 */
export const GrantOriginWithData = new GrantOriginWithData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListGrantOriginsResponse$Type extends MessageType<ListGrantOriginsResponse> {
    constructor() {
        super("c1.api.app.v1.ListGrantOriginsResponse", [
            { no: 1, name: "origins", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GrantOriginWithData }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListGrantOriginsResponse
 */
export const ListGrantOriginsResponse = new ListGrantOriginsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchGrantReasonsRequest$Type extends MessageType<SearchGrantReasonsRequest> {
    constructor() {
        super("c1.api.app.v1.SearchGrantReasonsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 6, name: "grant_reason_types", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "4" } } } },
            { no: 7, name: "include_weak_reasons", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchGrantReasonsRequest
 */
export const SearchGrantReasonsRequest = new SearchGrantReasonsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchGrantReasonsResponse$Type extends MessageType<SearchGrantReasonsResponse> {
    constructor() {
        super("c1.api.app.v1.SearchGrantReasonsResponse", [
            { no: 1, name: "reasons", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GrantReason },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchGrantReasonsResponse
 */
export const SearchGrantReasonsResponse = new SearchGrantReasonsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantSource$Type extends MessageType<GrantSource> {
    constructor() {
        super("c1.api.app.v1.GrantSource", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GrantSource
 */
export const GrantSource = new GrantSource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppEntitlementUserBindingRequest$Type extends MessageType<GetAppEntitlementUserBindingRequest> {
    constructor() {
        super("c1.api.app.v1.GetAppEntitlementUserBindingRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAppEntitlementUserBindingRequest
 */
export const GetAppEntitlementUserBindingRequest = new GetAppEntitlementUserBindingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppEntitlementUserBindingResponse$Type extends MessageType<GetAppEntitlementUserBindingResponse> {
    constructor() {
        super("c1.api.app.v1.GetAppEntitlementUserBindingResponse", [
            { no: 1, name: "binding", kind: "message", T: () => AppEntitlementUserBinding }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAppEntitlementUserBindingResponse
 */
export const GetAppEntitlementUserBindingResponse = new GetAppEntitlementUserBindingResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveGrantDurationRequest$Type extends MessageType<RemoveGrantDurationRequest> {
    constructor() {
        super("c1.api.app.v1.RemoveGrantDurationRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.RemoveGrantDurationRequest
 */
export const RemoveGrantDurationRequest = new RemoveGrantDurationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveGrantDurationResponse$Type extends MessageType<RemoveGrantDurationResponse> {
    constructor() {
        super("c1.api.app.v1.RemoveGrantDurationResponse", [
            { no: 1, name: "binding", kind: "message", T: () => AppEntitlementUserBinding }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.RemoveGrantDurationResponse
 */
export const RemoveGrantDurationResponse = new RemoveGrantDurationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchExpiringAppEntitlementsCountRequest$Type extends MessageType<SearchExpiringAppEntitlementsCountRequest> {
    constructor() {
        super("c1.api.app.v1.SearchExpiringAppEntitlementsCountRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchExpiringAppEntitlementsCountRequest
 */
export const SearchExpiringAppEntitlementsCountRequest = new SearchExpiringAppEntitlementsCountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchExpiringAppEntitlementsCountResponse$Type extends MessageType<SearchExpiringAppEntitlementsCountResponse> {
    constructor() {
        super("c1.api.app.v1.SearchExpiringAppEntitlementsCountResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchExpiringAppEntitlementsCountResponse
 */
export const SearchExpiringAppEntitlementsCountResponse = new SearchExpiringAppEntitlementsCountResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppEntitlementUserBindingService
 */
export const AppEntitlementUserBindingService = new ServiceType("c1.api.app.v1.AppEntitlementUserBindingService", [
    { name: "ListAppUsersForIdentityWithGrant", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/entitlements/{app_entitlement_id}/users/{identity_user_id}/grants", group: "App Entitlement User Binding" }] } }, I: ListAppUsersForIdentityWithGrantRequest, O: ListAppUsersForIdentityWithGrantResponse },
    { name: "SearchPastGrants", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/past-grants", group: "App Entitlement User Binding History" }] } }, I: SearchPastGrantsRequest, O: SearchPastGrantsResponse },
    { name: "SearchGrantFeed", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/grants/feed", group: "App Entitlement User Binding Feed" }] } }, I: SearchGrantFeedRequest, O: SearchGrantFeedResponse },
    { name: "SearchAppUsersWithStandingHighRiskGrants", options: { "authz.method": { role: "EDITOR" } }, I: SearchAppUsersWithStandingHighRiskGrantsRequest, O: SearchAppUsersWithStandingHighRiskGrantsResponse },
    { name: "ListGrantOrigins", options: { "authz.method": { role: "VIEWER" } }, I: ListGrantOriginsRequest, O: ListGrantOriginsResponse },
    { name: "SearchGrantReasons", options: { "authz.method": { role: "VIEWER" } }, I: SearchGrantReasonsRequest, O: SearchGrantReasonsResponse },
    { name: "ListMemberships", options: { "authz.method": { role: "VIEWER" } }, I: ListMembershipsRequest, O: ListMembershipsResponse },
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: GetAppEntitlementUserBindingRequest, O: GetAppEntitlementUserBindingResponse },
    { name: "UpdateGrantDuration", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/entitlements/{app_entitlement_id}/users/{app_user_id}/update-grant-duration", group: "App Entitlement User Binding" }] } }, I: UpdateGrantDurationRequest, O: UpdateGrantDurationResponse },
    { name: "RemoveGrantDuration", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/entitlements/{app_entitlement_id}/users/{app_user_id}/remove-grant-duration", group: "App Entitlement User Binding" }] } }, I: RemoveGrantDurationRequest, O: RemoveGrantDurationResponse },
    { name: "SearchExpiringAppEntitlementsCount", options: { "authz.method": { role: "VIEWER" } }, I: SearchExpiringAppEntitlementsCountRequest, O: SearchExpiringAppEntitlementsCountResponse }
]);
